/**
 * @generated SignedSource<<3585aa4354ebb659256b7160c70e6028>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type checkoutUIReducer_buyer$data = {
  readonly hasSupportedChargeCurrency: boolean | null;
  readonly preferences: {
    readonly currency: Currency | null;
  } | null;
  readonly " $fragmentType": "checkoutUIReducer_buyer";
};
export type checkoutUIReducer_buyer$key = {
  readonly " $data"?: checkoutUIReducer_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutUIReducer_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutUIReducer_buyer"
};

(node as any).hash = "f9f1c56e29cc7ac88a51a237cb4c5c0f";

export default node;
